/**
 * Runtime environment:
 * - In development: always use process.env (from .env via env-cmd).
 * - In production build: use window.__ENV__ (injected via env-config.js after build)
 *   first, then fall back to build-time process.env.
 */
function getEnv(key: string): string | undefined {
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment) {
    return process.env[key];
  }
  const runtime = typeof window !== 'undefined' && window.__ENV__;
  if (runtime && runtime[key] !== undefined && runtime[key] !== '') {
    return runtime[key];
  }
  return process.env[key];
}

const runtimeEnv = {
  get API_URL(): string | undefined {
    return getEnv('REACT_APP_API_URL');
  },
  get ENV(): string | undefined {
    return getEnv('REACT_APP_ENV');
  },
  get BUILD_VERSION(): string | undefined {
    return getEnv('REACT_APP_BUILD_VERSION');
  },
  get GA(): string | undefined {
    return getEnv('REACT_APP_GA');
  },
  get HOTJAR_ID(): string | undefined {
    return getEnv('REACT_APP_HOTJAR_ID');
  },
  get HOTJAR_VERSION(): string | undefined {
    return getEnv('REACT_APP_HOTJAR_VERSION');
  },
};

// Sidebar items are gated by a single CSV env var, REACT_APP_SIDEBAR_DISABLED.
// Listing an item's flagKey here hides it; an empty/unset value shows everything.
let cachedDisabledRaw: string | undefined;
let cachedDisabledSet: Set<string> = new Set();

function getDisabledSidebarSet(): Set<string> {
  const raw = getEnv('REACT_APP_SIDEBAR_DISABLED') ?? '';
  if (raw !== cachedDisabledRaw) {
    cachedDisabledRaw = raw;
    cachedDisabledSet = new Set(
      raw
        .split(',')
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean)
    );
  }
  return cachedDisabledSet;
}

export function isSidebarFeatureEnabled(flagKey?: string): boolean {
  if (!flagKey) return true;
  return !getDisabledSidebarSet().has(flagKey.toLowerCase());
}

export default runtimeEnv;
